export const SEARCH_RESULT_CLEAR = "SEARCH_RESULT_CLEAR";
export const SEARCH_RESULT_STARTED = "SEARCH_RESULT_STARTED";
export const SEARCH_RESULT_SUCCESS = "SEARCH_RESULT_SUCCESS";
export const SEARCH_RESULT_FAILURE = "SEARCH_RESULT_FAILURE";
export const SEARCH_FILTER_SELECTION = "SEARCH_FILTER_SELECTION";
export const SEARCH_UPDATE_SEARCH_TEXT = "SEARCH_UPDATE_SEARCH_TEXT";
export const SEARCH_SUGGESTIONS_STARTED = "SEARCH_SUGGESTIONS_STARTED";
export const SEARCH_SUGGESTIONS_DONE = "SEARCH_SUGGESTIONS_DONE";
export const SEARCH_HISTORY_STARTED = "SEARCH_HISTORY_STARTED";
export const SEARCH_HISTORY_DONE = "SEARCH_HISTORY_DONE";
export const SEARCH_UPDATE_SORT = "SEARCH_UPDATE_SORT";
export const SEARCH_UPDATE_STARTED = "SEARCH_UPDATE_STARTED";
